// extracted by mini-css-extract-plugin
module.exports = {"viewTypeSelect":"styles_viewTypeSelect__1JIqA","viewTypeSelectItem":"styles_viewTypeSelectItem__34kwp","viewTypeSelectWeekView":"styles_viewTypeSelectWeekView__1jx1a"};